import { Controller } from 'stimulus';

export default class extends Controller {
  get openClassName() {
    return this.data.get('open-with') || 'open';
  }

  open() {
    this.element.classList.add(this.openClassName);
  }

  close(event) {
    event && event.preventDefault();
    this.element.classList.remove(this.openClassName);
  }
}
